export default function BrandMark({ compact = false }) {
  return (
    <div className={`aden-brand-mark ${compact ? 'aden-brand-mark--compact' : ''}`} aria-label="Aden Technology">
      <span className="aden-brand-at"><b>A</b><i/><b>T</b></span>
      {!compact && <span className="aden-brand-name"><strong>Aden</strong><small>Technology</small></span>}
    </div>
  )
}
